/** Shared page header (UX review G2) — one consistent title/subtitle/actions
 * pattern so pages stop mixing h4/h5 headers, double Containers and
 * misaligned action buttons. */
import React from "react";
import { Box, Typography } from "@mui/material";

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Action buttons/chips rendered right-aligned. */
  actions?: React.ReactNode;
}

export default function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        flexWrap: "wrap",
        gap: 2,
        mb: 3,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexShrink: 0 }}>
          {actions}
        </Box>
      )}
    </Box>
  );
}
